import { Alert as MuiAlert, AlertProps as MuiAlertProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

export interface AlertProps extends MuiAlertProps {
  size?: "small" | "medium" | "large";
}

const extraProps: PropertyKey[] = ["size"];

// TODO: css can be improved and simplified using `variant` prop instead: https://mui.com/material-ui/customization/theme-components/#theme-style-overrides
const StyledAlert = styled(MuiAlert, {
  shouldForwardProp: (prop) => !extraProps.includes(prop),
})<AlertProps>(({ theme, size }) => {
  const { spacing, typography } = theme;

  switch (size) {
    case "small":
      return {
        fontSize: typography.small.fontSize,
        lineHeight: typography.small.lineHeight,
        alignItems: "center",
        "& .MuiAlert-icon": {
          fontSize: typography.small.fontSize,
          margin: 0,
          paddingTop: theme.spacing(2),
          paddingLeft: theme.spacing(1.5),
        },
        "& .MuiAlert-message": {
          minHeight: spacing(5),
          padding: spacing(0.5, 1.5),
          fontSize: "12px",
        },
        "& .MuiButtonBase-root": {
          fontSize: "12px",
          maxHeight: "16px !important",
          minHeight: "16px",
          margin: "2px 0px",
        },
        "& .MuiIconButton-root": {
          minWidth: "16px",
          maxWidth: "16px",
        },
      };
    case "large":
      return {
        lineHeight: typography.regular.lineHeight,
        alignItems: "center",
        "& .MuiAlert-icon": {
          fontSize: "15px",
          margin: 0,
          paddingTop: theme.spacing(2),
          paddingLeft: theme.spacing(3),
        },
        "& .MuiAlert-message": {
          minHeight: spacing(10),
          padding: spacing(1.5, 2.5),
        },
        "& .MuiButtonBase-root": {
          fontSize: "14px",
          maxHeight: "24px !important",
          minHeight: "24px",
          margin: "8px 6px",
        },
        "& .MuiIconButton-root": {
          minWidth: "24px",
          maxWidth: "24px",
        },
      };
    default: // default is medium
      return {
        lineHeight: typography.regular.lineHeight,
        alignItems: "center",
        "& .MuiAlert-icon": {
          fontSize: "15px",
          margin: 0,
          paddingTop: theme.spacing(2),
          paddingLeft: theme.spacing(2.5),
        },
        "& .MuiAlert-message": {
          minHeight: spacing(7),
          padding: spacing(1.5, 2.5),
        },
        "& .MuiButtonBase-root": {
          fontSize: "13px",
          maxHeight: "20px !important",
          minHeight: "20px",
          margin: "4px 2px",
        },
        "& .MuiIconButton-root": {
          minWidth: "20px",
          maxWidth: "20px",
        },
      };
  }
});

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  (props: AlertProps, ref) => {
    return <StyledAlert {...props} ref={ref} />;
  },
);
